const fieldsFor = (source, fields) =>
  Object.fromEntries(fields.map(field => [field, source?.[field]]));

const snapshot = value => JSON.stringify(value);

const IDENTITY_FIELDS = [
  'name',
  'description',
  'productName',
  'persona',
  'language',
  'responseLength',
  'unknownResponse',
  'resolutionMessage',
  'featureCitation',
  'featureContactAttributes',
  'temperature',
];

const BEHAVIOR_FIELDS = ['responseGuidelinesText', 'guardrailsText'];

const FAQ_FIELDS = [
  'faqLearningSourceGroupsText',
  'faqLearningQuestionsGroupJid',
];

const KNOWLEDGE_FIELDS = ['featureFaq', 'featureMemory'];

const HANDOFF_FIELDS = [
  'handoffMessage',
  'businessHoursHandoffMessage',
  'afterHoursHandoffMessage',
];

const PUBLICATION_FIELDS = [
  'qualificationMode',
  'preSchedulingLinkUrl',
  'operationScope',
  'allowedChannels',
  'allowedOriginsText',
  'audienceScopeRulesText',
  'directWhatsappBehavior',
  'websiteDirectLinkPolicy',
  'fallbackTeamId',
  'outOfHoursBehavior',
];

const PUBLICATION_LIFECYCLE_FIELDS = ['publicationMode', 'rolloutPercent'];

const MEMORY_DRAFT_FIELDS = ['memoryType', 'key', 'content'];

export const captureAgentFormState = (form, memoryForm) => ({
  identity: snapshot(fieldsFor(form, IDENTITY_FIELDS)),
  behavior: snapshot(fieldsFor(form, BEHAVIOR_FIELDS)),
  knowledge: snapshot(fieldsFor(form, KNOWLEDGE_FIELDS)),
  faq: snapshot(fieldsFor(form, FAQ_FIELDS)),
  handoff: snapshot(fieldsFor(form, HANDOFF_FIELDS)),
  publication: snapshot(fieldsFor(form, PUBLICATION_FIELDS)),
  publicationLifecycle: snapshot(fieldsFor(form, PUBLICATION_LIFECYCLE_FIELDS)),
  memoryDraft: snapshot(fieldsFor(memoryForm, MEMORY_DRAFT_FIELDS)),
});

export const dirtyAgentFormGroups = (baseline, current) =>
  Object.fromEntries(
    Object.keys(current).map(group => [
      group,
      Boolean(baseline?.[group]) && baseline[group] !== current[group],
    ])
  );

export const dirtyAgentSections = dirtyGroups => ({
  identity: Boolean(dirtyGroups.identity || dirtyGroups.behavior),
  knowledge: Boolean(
    dirtyGroups.knowledge || dirtyGroups.faq || dirtyGroups.memoryDraft
  ),
  handoff: Boolean(dirtyGroups.handoff),
  publication: Boolean(
    dirtyGroups.publication || dirtyGroups.publicationLifecycle
  ),
});
